import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export const useUserRole = () => {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ['user-role', user?.id],
    queryFn: async () => {
      if (!user?.id) {
        return 'user';
      }
      
      const { data, error } = await supabase.rpc('get_user_role', {
        user_uuid: user.id
      });
      
      if (error) {
        console.error('Error fetching user role:', error);
        return 'user';
      }
      
      return data || 'user';
    },
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useHasAdminAccess = () => {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ['has-admin-access', user?.id],
    queryFn: async () => {
      if (!user?.id) {
        return false;
      }
      
      const { data, error } = await supabase.rpc('has_admin_access', {
        user_uuid: user.id
      });
      
      if (error) {
        console.error('Error checking admin access:', error);
        return false;
      }
      
      return data || false;
    },
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};